import {
  IonContent,
  IonPage,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonButton,
  IonIcon,
  IonList,
  IonItem,
  IonLabel,
} from '@ionic/react';
import { wallet, gameController, person, gift, tvOutline } from 'ionicons/icons';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { useAuth } from '../contexts/AuthContext';
import { useWallet } from '../contexts/WalletContext';
import AppHeader from '../components/AppHeader';
import BottomNav from '../components/BottomNav';
import './Dashboard.css';

const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useAuth();
  const { balance, transactions, loading } = useWallet();

  return (
    <IonPage>
      <AppHeader title="Dashboard" showMenuButton={false} showBackButton={false} />
      <IonContent fullscreen className="ion-padding">
        <div className="dashboard-container">
          {/* Coin Balance Card */}
          <IonCard className="balance-card">
            <IonCardContent>
              <div className="balance-amount">
                <span className="coin-icon">🪙</span>
                <span className="amount">{loading ? '...' : balance.toLocaleString()}</span>
              </div>
              <IonButton
                expand="block"
                color="primary"
                onClick={() => navigate('/wallet')}
              >
                View Wallet
              </IonButton>
            </IonCardContent>
          </IonCard>

          {/* Quick Actions */}
          <div className="quick-actions-grid">
            <IonCard
              className="action-card"
              onClick={() => navigate('/games')}
            >
              <IonCardContent>
                <IonIcon icon={gameController} className="action-icon" />
                <h3>Play Games</h3>
                <p>Earn coins by playing</p>
              </IonCardContent>
            </IonCard>

            <IonCard
              className="action-card"
              onClick={() => navigate('/wallet')}
            >
              <IonCardContent>
                <IonIcon icon={wallet} className="action-icon" />
                <h3>My Wallet</h3>
                <p>View transactions</p>
              </IonCardContent>
            </IonCard>

            <IonCard
              className="action-card"
              onClick={() => navigate('/watch-ad')}
            >
              <IonCardContent>
                <IonIcon icon={tvOutline} className="action-icon" />
                <h3>Watch Ads</h3>
                <p>Earn coins</p>
              </IonCardContent>
            </IonCard>

            <IonCard
              className="action-card"
              onClick={() => navigate('/profile')}
            >
              <IonCardContent>
                <IonIcon icon={person} className="action-icon" />
                <h3>Profile</h3>
                <p>Settings & info</p>
              </IonCardContent>
            </IonCard>
          </div>

          {/* Recent Activity */}
          <IonCard className="transactions-card">
            <IonCardHeader>
              <IonCardTitle>Recent Activity</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              {transactions.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '3rem 2rem' }}>
                  <p style={{ color: 'var(--ion-text-color-step-600)', margin: 0, fontSize: '0.95rem' }}>
                    No recent activity
                  </p>
                </div>
              ) : (
                <>
                  <IonList className="transactions-list">
                    {transactions.slice(0, 5).map((transaction, index) => {
                      const icon = transaction.type === 'earn' ? '🎮' : transaction.type === 'spend' ? '💸' : '🎁';
                      return (
                        <IonItem 
                          key={transaction.id}
                          className={`transaction-item ${index % 2 === 0 ? 'even' : 'odd'}`}
                        >
                          <IonLabel>
                            <h2>{icon} {transaction.description}</h2>
                            <p>{format(transaction.timestamp, 'MMM d, yyyy h:mm a')}</p>
                          </IonLabel>
                          <span
                            className={`transaction-amount ${
                              transaction.amount > 0 ? 'positive' : 'negative'
                            }`}
                            slot="end"
                          >
                            {transaction.amount > 0 ? '+' : ''}
                            {transaction.amount}
                          </span>
                        </IonItem>
                      );
                    })}
                  </IonList>
                  {transactions.length > 5 && (
                    <div style={{ padding: '16px 20px', borderTop: '1px solid var(--ion-color-step-200, rgba(255, 255, 255, 0.1))' }}>
                      <IonButton
                        fill="clear"
                        expand="block"
                        onClick={() => navigate('/wallet')}
                        style={{ '--color': 'var(--ion-color-primary)', margin: 0 }}
                      >
                        View More
                      </IonButton>
                    </div>
                  )}
                </>
              )}
            </IonCardContent>
          </IonCard>
        </div>
      </IonContent>
      <BottomNav />
    </IonPage>
  );
};

export default Dashboard;

